import { useState } from 'react';

import axios from 'axios';
import { toast } from 'react-toastify';
import { getError } from '../../../../utils';
import 'react-toastify/dist/ReactToastify.css';
import '../css/login.css';

import { Form } from 'react-bootstrap';
import AnimatedInput from './AnimatedInput';
import { ArrowLeft } from 'lucide-react';

const loginFields = [
  {
    key: 'email',
    type: 'email',
    name: 'Email',
    icon: 'fa-solid fa-envelope-open-text',
    required: true,
    errorKey: 'email',
  },
];

const ForgotPass = ({ onHome, onOTP }) => {
  const initialForm = {
    email: '',
  };

  const [formData, setFormData] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const { data } = await axios.post('/forgot-password', formData);
      onOTP();
      toast.success(data.message);
    } catch (err) {
      const messages = err.response?.data?.messages;
      if (err.response?.status === 422 && messages) {
        setErrors(messages);
      } else {
        toast.error(getError(err));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section>
      <Form onSubmit={submitHandler} className="modalOverideForm">
        {loginFields.map((field, idx) => (
          <div key={idx} className="mb-4">
            <AnimatedInput
              field={field}
              value={formData[field.key]}
              onChange={(e) =>
                setFormData({ ...formData, [field.key]: e.target.value })
              }
              error={errors[field.errorKey]}
            />{' '}
            {field.type === 'password' && (
              <aside className="note-pass">
                <strong style={{ color: 'var(--red)' }}>Lưu ý: </strong>Mật khẩu
                phải chứa ít nhất 8 ký tự, chữ hoa, chữ thường và số.
              </aside>
            )}
          </div>
        ))}

        <div className="d-flex justify-content-center align-items-center mb-3">
          <button
            type="submit"
            className="mb-2 w-100 btn-forgot"
            style={{ opacity: isLoading ? '0.7' : '1' }}
            disabled={isLoading}
          >
            {isLoading ? (
              <i className="fas fa-spinner fa-spin loading-icon" />
            ) : (
              'Tiếp tục'
            )}
          </button>
        </div>
        <p className="text-center m-0">
          <span className="prev-home" onClick={onHome}>
            <ArrowLeft style={{ width: '16px' }} /> Quay lại trang chủ
          </span>
        </p>
      </Form>
    </section>
  );
};
export default ForgotPass;
